export const ErrorTypes = {
    RATE_LIMIT: 'RateLimit',
    REPEAT_REQUEST: 'RepeatRequest',
    GSC_ERROR: 'GscError',
};
